'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sailboat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M25.9 400l48 96 364.2 0 48-96-238.1 0c-5.3 0-10.7 0-16 0L25.9 400zm39.3-81.3c.2 .4 .4 .9 .7 1.3L232 320 232 98.5 65.2 318.7zM248 48.6l0 271.4 200.2 0C381.5 229.5 314.7 139 248 48.6z', 'M232 72l0-72 16 21.7 220.2 298.3 11.8 16-232 0 0 48 264 0-8 16-56 112-384 0-56-112-8-16 232 0 0-48-200 0 12.1-16 187.9-248zm16 248L448.3 320 248 48.6 248 320zm-16 0L232 98.5 64.2 320 232 320zm0 80l-206.1 0 48 96 364.2 0 48-96-238.1 0 0 0-16 0 0 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;